<template>
  <div class="not-found-wrapper">
    <div class="not-found-content">
      <div class="not-found-code">404</div>
      <h1 class="not-found-title">Página no encontrada</h1>
      <p class="not-found-subtitle">
        La página que buscas no existe o fue movida.
      </p>
      <button class="not-found-btn" @click="$router.push('/dashboard')">
        <i class="el-icon-arrow-left"></i> Regresar al Dashboard
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "404View"
};
</script>

<style lang="scss" scoped>
.not-found-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fb;
}
.not-found-content {
  text-align: center;
  padding: 40px 24px;
}
.not-found-code {
  font-size: 96px;
  font-weight: 800;
  color: #3ecfb4;
  line-height: 1;
  margin-bottom: 16px;
  letter-spacing: -4px;
}
.not-found-title {
  font-size: 26px;
  font-weight: 700;
  color: #31355c;
  margin: 0 0 10px;
}
.not-found-subtitle {
  font-size: 15px;
  color: #909399;
  margin: 0 0 32px;
}
.not-found-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: #3ecfb4;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #36c5ab;
  }
}
</style>
